const USERS = {
    COLLECTION: {
        url: '/users',
        queryKey: 'getUsers'
    },
    DETAILS: {
        url: '/users/:userId',
        queryKey: 'getUser'
    },
    RESET_PASSWORD: {
        url: '/users/:userId/resendMail'
    },
    FORGOTTEN_PASSWORD: {
        url: '/forgottenPassword'
    },
    UPDATE_PASSWORD: {
        url: '/users/updatePassword'
    },
    PROFILE: {
        url: '/userProfiles/:organizationId',
        queryKey: 'getProfiles'
    },
    UPDATE_PERMISSIONS: {
        url: '/users/:userId/permissions'
    },
    REMOVE_USER: {
        url: '/users/:userId'
    },
    ACTIVATE_USER: {
        url: '/users/activate'
    },
    DEACTIVATE_USER: {
        url: '/users/deactivate'
    },
    EXPORT_MONETICS_USERS: {
        url: '/moneticsUsers/export'
    }
};

export default USERS;